module.exports = __webpack_public_path__ + "static/media/volunteer2.27d01cdf.webp";